export var COUNTRY_CODE;
(function (COUNTRY_CODE) {
    COUNTRY_CODE["US"] = "US";
    COUNTRY_CODE["CANADA"] = "CA";
})(COUNTRY_CODE || (COUNTRY_CODE = {}));
